import { useSelector } from "react-redux";
import { Route, Routes } from "react-router-dom";
import AllTournaments from "../pages/dashboardPage/tournamentSettings/allTournaments/AllTournaments";
import OneTournamentTables from "../pages/dashboardPage/tournamentTables/oneTournamentTables/OneTournamentTables";

const TournamentTablesNavigator = () => {
  const { rolePermissions } = useSelector((state) => state.user);

  return (
    <Routes>
      {rolePermissions.includes("view-tables") && (
        <Route
          path="/show-tournament-tables/:tournamentId"
          element={<OneTournamentTables />}
        ></Route>
      )}
      {rolePermissions.includes("view-tournaments") && (
        <Route
          path="/show-all-tournaments"
          element={<AllTournaments />}
        ></Route>
      )}
      {rolePermissions.includes("view-tournaments") && (
        <Route path="*" element={<AllTournaments />} />
      )}
    </Routes>
  );
};

export default TournamentTablesNavigator;
